import * as Gerencia from './Gerencia';
import * as Relatorio from './Relatorio';

import { default as Dashboard } from './Dashboard';
import { default as Contrato } from './Contrato';
import { default as Projetos } from './Projetos';
import { default as OS } from './OS';
import { default as AprovarOS } from './AprovarOS';

export default {
  Dashboard,
  Gerencia,
  Contrato,
  Projetos,
  OS,
  AprovarOS,
  Relatorio,
};
